"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("./helpers");
var base_1 = __importDefault(require("./scripts/base"));
var checkForTrackerAndName = function (analytic) {
    var trackerType = analytic.type, name = analytic.name;
    if (!trackerType || !name) {
        // eslint-disable-next-line no-console
        console.warn('Missing type and/or name for this dispatched action');
        return false;
    }
    return analytic;
};
var getListOfValidAnalyticsToCall = function (analytics) {
    var isArray = Array.isArray(analytics);
    if (isArray)
        return analytics.map(checkForTrackerAndName).filter(Boolean);
    return [checkForTrackerAndName(analytics)].filter(Boolean);
};
var getAllClients = function (configs) {
    return Object.keys(configs)
        .map(function (x) { return (configs[x] instanceof base_1.default ? x : false); })
        .filter(Boolean);
};
var middleware = function (configs) {
    var track = helpers_1.tracker(configs);
    var allDefaultClients = getAllClients(configs);
    return function (store) { return function (next) { return function (action) {
        var dispatch = store.dispatch;
        var type = action.type, meta = action.meta;
        var isLoadingOrErrorAction = /(LOADING|ERROR)$/i.test(type);
        next(action);
        if (!meta || !meta.analytics || isLoadingOrErrorAction)
            return;
        getListOfValidAnalyticsToCall(meta.analytics).forEach(function (analytic) {
            var trackerType = analytic.type, name = analytic.name, clients = analytic.clients, theRestIsEventData = __rest(analytic, ["type", "name", "clients"]);
            // TODO: not too happy with this...
            (clients || allDefaultClients).forEach(function (analyticType) {
                var eventName = "@@analytics/ANALYTICS_" + analyticType.toUpperCase() + "_" + (trackerType || '').toUpperCase();
                dispatch({
                    type: eventName,
                    payload: theRestIsEventData[analyticType]
                });
            });
            track(trackerType, name, theRestIsEventData, clients);
        });
    }; }; };
};
exports.default = middleware;
